import React from "react";
import { Col } from "reactstrap";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import whiteLogo from "../../assets/images/buypass-logo-white.png"
import businessAvenue from "../../assets/images/Business-Avenue.png"

// Import Images
import logoLight from "../../assets/images/logo-light.png";

const AuthSlider = () => {
    return (
        <React.Fragment>

            <Col lg={6} className="TopCol">
                <div className=" p-lg-5 auth-one-bg h-100 topBox">
                    <div className="bg-overlay"></div>
                    <div className="position-relative ms-5 h-100 d-flex flex-column loginSidelogo gap-4 justify-content-center">
                        <div className=" publicLogoimg">
                            <img src={whiteLogo} alt=""
                                className=""
                                style={{ width: "200px", height: "46px" }}
                            />
                        </div>
                        <div className=" businessdv">
                            <h4 className="business">Business  Avenue</h4>
                        </div>
                        <div className="BottomText">
                            <h3 className="text-white">Your digital shop to boost <br /> your business. </h3>

                        </div>
                    </div>
                </div>
            </Col>
        </React.Fragment >
    );
};

export default AuthSlider;